angular.module('nv.shared.services.sorter.agGrid').factory('BooleanYesNoFilter', function(AgGridFilterService) {
  let OPTION_TEMPLATE =
    '<div style="margin-bottom: 4px">' +
    '  <label>' +
    '    <input CHECKED type="checkbox"/>OPTION' +
    '  </label>' +
    '</div>';

  let BooleanYesNoFilter = function() {
    // empty block?
  };

  BooleanYesNoFilter.prototype.init = function(params) {
    this.filterChangedCallback = params.filterChangedCallback;
    this.field = params.colDef.field;
    // Examples of this.model:
    // * { in: [true] } - display only where the value matches "true"
    // * { in: [true, false] } - display where the value matches "true" or "false"
    // * undefined - display all values (filter disabled)
    this.model = undefined;
    this.numOfFilterChoices = 3;
    this._updateFilterFunction(); // always call this after this.model changes
  };

  BooleanYesNoFilter.prototype._updateFilterFunction = function() {
    let model = this.model || { in: [true, false, null] };
    this.filter = AgGridFilterService.makeBooleanYesNoFilter(this.field, model);
  };

  BooleanYesNoFilter.prototype._optionChecked = function(value, checked) {
    let model = this.model || { in: [true, false, null] };
    if (checked) {
      model.in.push(value);
    } else {
      model.in = _.difference(model.in, [value]);
    }

    model.in = _.uniq(model.in);
    if (model.in.length === this.numOfFilterChoices) {
      this.model = undefined;
    } else {
      this.model = model;
    }
  };

  BooleanYesNoFilter.prototype._isOptionChecked = function(value) {
    if (!this.model) return true;
    return _.includes(this.model.in, value);
  };

  BooleanYesNoFilter.prototype._buildGui = function() {
    this._eGui = this._eGui || document.createElement('div');
    let eGui = this._eGui;
    eGui.style.padding = '8px';

    let self = this;
    let inputs = [{ label: '(Blanks)', value: null }, { label: 'Yes', value: true }, { label: 'No', value: false }];
    self.numOfFilterChoices = inputs.length;

    // Clear out eGui
    while (eGui.firstChild) {
      eGui.removeChild(eGui.firstChild);
    }

    _.each(inputs, function(option) {
      // HTML escape hack
      let div = document.createElement('div');
      div.appendChild(document.createTextNode(option.label));

      let html = OPTION_TEMPLATE.replace('OPTION', div.innerHTML);
      html = html.replace('CHECKED', self._isOptionChecked(option.value) ? 'checked' : '');
      let eDiv = document.createElement('div');
      eDiv.innerHTML = html;

      let eCheckbox = eDiv.querySelector('input');
      eCheckbox.addEventListener('click', function() {
        self._optionChecked(option.value, eCheckbox.checked);
        self._updateFilterFunction();
        self.filterChangedCallback();
      });

      eGui.appendChild(eDiv);
    });
  };

  BooleanYesNoFilter.prototype.getGui = function() {
    this._buildGui();
    return this._eGui;
  };

  BooleanYesNoFilter.prototype.doesFilterPass = function(params) {
    return this.filter(params.data);
  };

  BooleanYesNoFilter.prototype.isFilterActive = function() {
    return this.model && this.model.in.length < this.numOfFilterChoices;
  };

  BooleanYesNoFilter.prototype.getModel = function() {
    if (this.isFilterActive()) {
      return angular.copy(this.model);
    }
    return null;
  };

  BooleanYesNoFilter.prototype.setModel = function(m) {
    this.model = m;
    this._updateFilterFunction();
    this._buildGui();
  };

  return BooleanYesNoFilter;
});
